/**
 * Config Column Presets
 * Predefined configuration options for common service types
 */
import type { ConfigColumnOptions } from './config-columns'

// ============================================================================
// PREDEFINED CONFIG COLUMN PRESETS
// ============================================================================

export const CONFIG_PRESETS = {
    // Cloud VPS / VCloud
    cpu: {
        key: 'cpu',
        title: 'CPU',
        configName: ['cpu', 'vcore', 'vcpu'],
        width: 80,
    },
    memory: { key: 'memory', title: 'RAM', configName: 'memory', width: 100 },
    disk: { key: 'disk', title: 'Disk', configName: 'disk', width: 100 },
    ip: { key: 'ip', title: 'IP', configName: 'ip', width: 80 },
    bandwidth: {
        key: 'bandwidth',
        title: 'Bandwidth',
        configName: 'bandwidth',
        width: 100,
    },

    // Server VBM
    processor: {
        key: 'processor',
        title: 'Server/Processor',
        configName: ['processor', 'server'],
        width: 200,
    },
    power: {
        key: 'power',
        title: 'Power',
        configName: 'power',
        width: 100,
        useCapacityCommitment: true,
    },
    peakBandwidth: {
        key: 'peak_bandwidth',
        title: 'Peak BW',
        configName: 'peak-bandwidth',
        width: 100,
    },

    // Colocation
    colocationU: {
        key: 'u',
        title: 'U',
        configName: ['u', 'colocation-u'],
        width: 80,
    },
    localBandwidth: {
        key: 'local',
        title: 'Bandwidth Local',
        configName: 'local',
        width: 130,
    },
    globalBandwidth: {
        key: 'global',
        title: 'Bandwidth Global',
        configName: 'global',
        width: 130,
    },

    // Email
    emailAccount: {
        key: 'email_account',
        title: 'Accounts',
        configName: ['email-account', 'email-account-2'],
        width: 100,
    },
    emailStorage: {
        key: 'email_storage',
        title: 'Storage',
        configName: 'email-storage',
        width: 100,
    },
    emailDomain: {
        key: 'email_domain',
        title: 'Domains',
        configName: 'email-domain',
        width: 100,
    },
    emailAttachment: {
        key: 'email_attachment',
        title: 'Attachment',
        configName: 'email-attachment',
        width: 100,
    },

    // VNIS
    domains: {
        key: 'domains',
        title: 'Domains',
        configName: 'domains',
        width: 100,
    },
    cdnTraffics: {
        key: 'cdn_traffics',
        title: 'CDN Traffic',
        configName: 'cdn_traffics',
        width: 120,
    },
    cdnRequests: {
        key: 'cdn_requests',
        title: 'CDN Requests',
        configName: 'cdn_requests',
        width: 120,
    },
    dnsQueries: {
        key: 'dns_queries',
        title: 'DNS Queries',
        configName: 'dns_queries',
        width: 120,
    },
    wafTraffics: {
        key: 'waf_traffics',
        title: 'WAF Traffic',
        configName: 'waf_traffics',
        width: 120,
    },
    wafRequests: {
        key: 'waf_requests',
        title: 'WAF Requests',
        configName: 'waf_requests',
        width: 120,
    },
    peakCdnTraffics: {
        key: 'peak_cdn_traffics',
        title: 'Peak CDN Traffic',
        configName: 'peak_cdn_traffics',
        width: 130,
    },
    peakWafTraffics: {
        key: 'peak_waf_traffics',
        title: 'Peak WAF Traffic',
        configName: 'peak_waf_traffics',
        width: 130,
    },
    peakCdnRequests: {
        key: 'peak_cdn_requests',
        title: 'Peak CDN Requests',
        configName: 'peak_cdn_requests',
        width: 140,
    },
    peakWafRequests: {
        key: 'peak_waf_requests',
        title: 'Peak WAF Requests',
        configName: 'peak_waf_requests',
        width: 140,
    },

    // Hosting
    storage: {
        key: 'storage',
        title: 'Storage',
        configName: 'storage',
        width: 100,
    },
    website: {
        key: 'website',
        title: 'Website',
        configName: 'website',
        width: 100,
    },
    mysql: {
        key: 'mysql',
        title: 'MySQL',
        configName: ['mysql', 'my-sql'],
        width: 100,
    },
} as const satisfies Record<string, ConfigColumnOptions>

export type ConfigPresetKey = keyof typeof CONFIG_PRESETS
